module.exports = __webpack_public_path__ + "static/img/theme_2.23fe302f.png";